import { render } from "./VociSpesaBusinessUnitsIva.vue?vue&type=template&id=0489b8e3&ts=true"
import script from "./VociSpesaBusinessUnitsIva.vue?vue&type=script&lang=ts"
export * from "./VociSpesaBusinessUnitsIva.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__